import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSettings } from "@/contexts/SettingsContext";
import { useLocale } from "@/contexts/LocaleContext";

export default function OpenBadge({ compact = false, testid = "open-badge" }) {
  const { settings } = useSettings();
  const { t } = useTranslation();
  const { locale } = useLocale();
  const [tick, setTick] = useState(0);

  // Re-render every 60s so the badge can refresh next-change label
  useEffect(() => {
    const id = setInterval(() => setTick((x) => x + 1), 60000);
    return () => clearInterval(id);
  }, []);

  if (!settings || !settings.status) return null;
  const { is_open_now, next_change_label } = settings.status;
  const label = next_change_label?.[locale] || next_change_label?.hr || "";

  return (
    <div
      data-testid={testid}
      data-open={is_open_now ? "true" : "false"}
      data-tick={tick}
      className={`inline-flex items-center gap-2 ${
        compact ? "text-[11px] px-2.5 py-1" : "text-xs px-3 py-1.5"
      } rounded-full border ${
        is_open_now
          ? "border-primary/40 bg-primary/10 text-primary"
          : "border-muted-foreground/30 bg-muted text-muted-foreground"
      }`}
    >
      <span
        className={`relative flex h-2 w-2 ${is_open_now ? "" : "opacity-60"}`}
        aria-hidden
      >
        {is_open_now && (
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-60" />
        )}
        <span
          className={`relative inline-flex rounded-full h-2 w-2 ${
            is_open_now ? "bg-primary" : "bg-muted-foreground/60"
          }`}
        />
      </span>
      <span className="font-medium tracking-wide uppercase">
        {is_open_now ? t("common.open_now") : t("common.closed_now")}
      </span>
      {label && (
        <>
          <span className="text-muted-foreground">·</span>
          <span className="lowercase text-muted-foreground first-letter:capitalize">
            {label}
          </span>
        </>
      )}
    </div>
  );
}
